import {
  getGetBrandsBrandIdAccountUrl,
  getPostPublicAccountsTwitterHandleUrl,
  getPostPublicAccountsUrl,
} from '@dashhudson/api-client/twitter/client';
import merge from 'lodash/merge';

import { createDashHttpClient, type HttpRequestConfig } from '@/apis/dash.http';
import { env } from '@/env';

export const http = createDashHttpClient(env.twitterApiUrl);
export const httpCamelCase = createDashHttpClient(env.twitterApiUrl, {
  camelizeKeys: true,
});

type MetricsWindow = { brandId: number; startDate?: string; endDate?: string; scale?: string };
type CsvExport = MetricsWindow & { filename?: string };

export const fetchUsers = (
  { handles, brandId }: { handles: string | string[]; brandId?: number },
  config: HttpRequestConfig = {},
) =>
  httpCamelCase.get(`/users`, {
    ...config,
    params: { handles, brandId },
  });

export async function getTwitterAccount(
  { brandId }: { brandId: number },
  config: HttpRequestConfig = {},
) {
  return http.get(getGetBrandsBrandIdAccountUrl(brandId), config);
}

export async function getTwitterAccounts(
  { brandIds }: { brandIds: number[] },
  config: HttpRequestConfig = {},
) {
  return http.get(
    `/brands/accounts`,
    merge(
      {
        params: {
          brandIds: brandIds.join(','),
        },
      },
      config,
    ),
  );
}

export async function refreshTwitterAdsAccount(
  { brandId }: { brandId: number },
  config: HttpRequestConfig = {},
) {
  return http.post(`/brands/${brandId}/account/refresh/ads_account`, {}, config);
}

export async function getFollowersCSV(
  { brandId, filename, startDate, endDate, scale }: CsvExport,
  config?: HttpRequestConfig,
) {
  return http.get(
    `/brands/${brandId}/exports/followers`,
    merge(
      {
        params: {
          filename,
          startDate,
          endDate,
          scale,
        },
      },
      config,
    ),
  );
}

export async function getMetricsCSV(
  { brandId, filename, startDate, endDate, scale }: CsvExport,
  config?: HttpRequestConfig,
) {
  return http.get(
    `/brands/${brandId}/exports/metrics`,
    merge(
      {
        params: {
          filename,
          startDate,
          endDate,
          scale,
        },
      },
      config,
    ),
  );
}

export async function getAllTweetsCSV(
  { brandId, filename, startDate, endDate, scale }: CsvExport,
  config?: HttpRequestConfig,
) {
  return http.get(
    `/brands/${brandId}/exports/all_tweets`,
    merge(
      {
        params: {
          filename,
          startDate,
          endDate,
          scale,
        },
      },
      config,
    ),
  );
}

export async function getTopTweetsCSV(
  { brandId, filename, startDate, endDate, scale, sortOrder }: CsvExport & { sortOrder?: string },
  config?: HttpRequestConfig,
) {
  return http.get(
    `/brands/${brandId}/exports/top_tweets`,
    merge(
      {
        params: {
          filename,
          startDate,
          endDate,
          scale,
          sortOrder,
        },
      },
      config,
    ),
  );
}

export async function getAccountMetrics(
  { brandId, startDate, endDate, scale }: MetricsWindow,
  config?: HttpRequestConfig,
) {
  return http.get(
    `/brands/${brandId}/metrics`,
    merge(
      {
        params: {
          startDate,
          endDate,
          scale,
        },
      },
      config,
    ),
  );
}

export async function addAccount({ handle }: { handle: string }, config: HttpRequestConfig = {}) {
  return http.post(getPostPublicAccountsTwitterHandleUrl(handle), {}, config);
}

export async function getPublicAccountsByIds(
  { twitterUserIds }: { twitterUserIds: string[] },
  config: HttpRequestConfig = {},
) {
  return httpCamelCase.post(getPostPublicAccountsUrl(), { twitterUserIds }, config);
}
